<template>
	<div>
		<div class="d-container" v-loading="loading">
			<main-header class="i-h" :child="child"></main-header>
			<div class="content">
				<div class="content-nav flex-sb">
					<div class="title col-center">参赛作品详情</div>
					<div class="right col-center">
						<div>
							<el-button type="primary" v-if="authority === 'expert'"
								@click="$router.push('/report?id='+id)">评审列表</el-button>
							<!-- <el-button type="primary" v-else-if="content.audit_status == 1 || content.audit_status == 2"
								@click="openDetail"
								plain>{{content.audit_status == 2 ? '该项目已评审，点击查看结果' : '该项目正在评审中，点击查看'}}</el-button> -->
							<el-button type="primary" @click="open"
								v-else-if="isEnd(content.end_date)">提交参赛作品</el-button>
							<!-- {{content.item_apply_id && content.item_apply_id !== '0' ? '修改项目申报书' : '提交项目申报书'}} -->
						</div>
					</div>
				</div>

				<div class="inner">
					<div class="title">
						<!-- {{content.title}} -->
						{{content.title}}
					</div>
					<div class="flex-center time-group">
						<div class="item col-center">
							<div>{{authority === 'expert' ? '评审开始时间：' : '开始时间：'}}</div>
							<div class="value">{{content.start_date}}</div>
						</div>
						<div class="item col-center" v-if="authority === 'expert'">
							<div style="flex-shrink: 0;">{{content.review_status == 3 ? '评审结束剩余：' : '评审结束时间：'}}</div>
							<el-statistic style="padding-top: 2px;" v-if="content.review_status == 3"
								:value-style="{color:'red',padding:'0',fontSize:'1rem',fontWeight:'bold'}"
								ref="statistic" format="HH时mm分ss秒" :value="new Date(content.audit_end_date)"
								time-indices>
							</el-statistic>
							<div class="value" v-else>{{content.audit_end_date}}</div>
						</div>
						<div class="item col-center" v-else>
							<div>结束时间：</div>
							<div class="value">{{content.end_date}}</div>
						</div>
					</div>
					<div v-html="content.content">

					</div>
					<div class="file" v-if="content.upload_file && content.upload_file.url" @click="download">
						<el-dropdown placement="right" @command="handleCommand($event, content.upload_file.url)">
							<div>附件：<span>{{content.upload_file.name}}</span></div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="download">下载<span
										style="color: red;margin-left: 0.625rem;">(预览较慢时请选择下载)</span></el-dropdown-item>
								<el-dropdown-item command="view">在线预览</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
					<div v-if="authority === 'expert'">
						<div class="end-review" :class="[['not','ing','about',''][content.review_status -1]]">
							{{['评审未开始','评审进行中','评审将结束','评审已结束'][content.review_status -1]}}
						</div>
					</div>
					<div v-else>
						<div class="end-review" v-if="!isEnd(content.end_date)">已结束</div>
					</div>
					<!-- <div class="end-review" v-if="!isEnd(content.end_date)">申报已结束</div> -->
				</div>
				<div class="inner" style="margin-bottom: 0;"
					v-if="(authority === 'expert' && content.review_notice) || (content.apply_notice)">
					<div class="title">
						{{authority === 'expert' ? '评审注意事项' : '参赛注意事项'}}
					</div>
					<div v-html="authority === 'expert' ? content.review_notice : content.apply_notice">

					</div>
					<div class="file"
						v-if="(authority === 'expert' && content.review_upload_file) || (authority !== 'expert' && content.apply_upload_file)">
						<el-dropdown placement="right"
							@command="handleCommand($event, authority === 'expert' ? content.review_upload_file.url : content.apply_upload_file.url)">
							<div>
								附件：<span>{{authority === 'expert' ? content.review_upload_file.name : content.apply_upload_file.name}}</span>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="download">下载<span
										style="color: red;margin-left: 0.625rem;">(预览较慢时请选择下载)</span></el-dropdown-item>
								<el-dropdown-item command="view">在线预览</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</div>
		</div>
		<review-submit ref="reviewSubmit" :theme="content.item_category" @close="dialogVisible = false"
			@submit="submitReport"></review-submit>
		<review-detail ref="reviewDetail" v-model="dialogVisible2" @close="dialogVisible2 = false"></review-detail>

		<!-- 提示框 -->
		<div class="detail-tips">
			<el-dialog :visible.sync="tipsDialogVisible" width="31.25rem" top="15vh">
				<div class="dialog-head flex-sb" slot="title">
					<div>提示</div>
					<div><i class="el-icon-close"></i></div>
				</div>
				<div class="dialog-content">
					<div class="title">您已提交参赛作品，请到<span class="dt-span"
							@click="$router.push('/history')">参赛作品记录</span>查看</div>
					<div class="tips">注意：如有修改，请在参赛截止时间前进行修改。</div>
				</div>
				<span slot="footer" class="dialog-footer">
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import mainHeader from '@/components/main-header/main-header'
	import reviewSubmit from './components/review-submit'
	import reviewDetail from './components/review-detail'
	import {
		getDetail,
	} from '@/common/api/home.js'
	import {
		submitReport,
		setCacheData,
		getCacheData
	} from '@/common/api/report.js'
	export default {
		name: '',
		props: {

		},
		components: {
			mainHeader,
			reviewSubmit,
			reviewDetail
		},
		data() {
			return {
				child: [],
				dialogVisible: false,
				dialogVisible2: false,
				tipsDialogVisible: false,
				loading: true,
				id: '',
				content: {}
			}
		},
		created() {
			this.id = this.$route.query.id
			if (this.id) {
				this.getDetail()
			}
		},
		mounted() {
			// 添加面包屑
			this.child = [{
				path: "/index",
				name: "Index",
				title: this.authority === 'expert' ? '参赛作品评审' : '首页'
			}]
		},
		methods: {
			async open() {
				let str = new Date(this.content.start_date).getTime(),
					tday = new Date().getTime()
				if (str > tday) {
					return this.$message.warning('未开始！')
				}
				// if (this.content.item_apply_id && this.content.item_apply_id !== '0') {
				// 	this.$refs.reviewSubmit.getDetail(this.content.item_apply_id)
				// }
				const {
					data
				} = await getCacheData({
					audit_project_id: this.id
				})
				console.log(data)
				this.$refs.reviewSubmit.open(data.data)
			},
			async getDetail() {
				this.loading = true
				try {
					const {
						data
					} = await getDetail({
						id: this.id
					})
					console.log(data)
					this.content = data
					if (data.item_apply_id && data.item_apply_id !== '0') {
						this.tipsDialogVisible = true
					}
					this.loading = false
				} catch (e) {
					this.loading = false
					console.log(e)
					//TODO handle the exception
				}

			},
			// 提交申报
			async submitReport(form, cacha) {
				if (cacha === 'cacha') {
					form = {
						data: form,
						audit_project_id: this.id
					}
				} else {
					form.audit_project_id = this.id
				}
				try {
					let fun = cacha === 'cacha' ? setCacheData : submitReport
					const {
						data
					} = await fun(form)
					if (cacha === 'cacha') {
						this.$message.success('暂存成功！')
					} else {
						this.$message.success('新增成功！')
						this.getDetail()
						// if (this.content.item_apply_id && this.content.item_apply_id !== '0') {
						// 	this.$message.success('修改成功！')
						// } else {

						// }
						this.$refs.reviewSubmit.close()
					}

					this.$refs.reviewSubmit.loading = false
				} catch (e) {
					console.log(e)
					this.$refs.reviewSubmit.loading = false
					//TODO handle the exception
				}
			},
			download() {
				window.open(this.content.upload_file.url)
			},
			isEnd(date) {
				let end = new Date(date).getTime(),
					time = new Date().getTime()
				if (time > end) {
					return false
				} else {
					return true
				}
			},
			// 查看申报详情
			openDetail(id) {
				this.dialogVisible2 = true;
				this.$refs.reviewDetail.init(this.content.item_apply_id)
			},
			// 操作菜单
			handleCommand(command, url) {
				if (command === 'download') {
					window.open(url, '_blank')
				} else {
					this.viewFile(url)
				}
			},
			// 在线预览
			viewFile(url) {
				let onlineViewType = ['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx']
				let fileTypeName = url.substring(url.lastIndexOf('.') + 1, url.length).split('?')[0]
				let isWord = onlineViewType.find((type) => type === fileTypeName)
				if (isWord) {
					url = 'http://view.officeapps.live.com/op/view.aspx?src=' + url
				}
				window.open(url, '_blank')
			}
		}

	}
</script>

<style lang="scss" scoped>
	.d-container {
		width: 100vw;
		height: 100vh;
		background-color: #F7F7F7;
		display: flex;
		flex-direction: column;

		.i-h {
			flex-shrink: 0;
		}

		.content {
			flex-grow: 1;
			height: 0;
			margin: 0.625rem;
			border-radius: 0.375rem;
			background-color: white;
			display: flex;
			flex-direction: column;
			overflow-y: auto;

			.content-nav {
				padding: 1.25rem;
				border-bottom: 1px solid #E7EBF0;
				flex-shrink: 0;

				.title {
					font-size: 1.5rem;
					font-weight: bold;
					position: relative;
					padding-left: 1.5rem;
				}

				.title::after {
					content: "";
					display: block;
					width: 0.25rem;
					height: 1rem;
					position: absolute;
					background-color: #4389E0;
					left: 0.625rem;
					top: 50%;
					margin-top: -8px;
				}

				.right {
					.search {
						padding: 0 4.375rem;
					}

					.search-btn {
						padding: 0 0.625rem;
					}
				}
			}

			.inner {
				width: 100%;
				max-width: 82.5rem;
				margin: 1.25rem auto;
				background: #F7FAFE;
				border-radius: 0.25rem;
				border: 1px solid #DCE1E7;
				padding: 1.25rem;
				box-sizing: border-box;
				position: relative;

				.title {
					text-align: center;
					font-size: 1.375rem;
					font-weight: bold;
				}

				.file {
					padding-top: 1.25rem;
					cursor: pointer;
					color: #666;
					font-weight: bold;
				}

				.file:hover {
					color: #4979ff;
					text-decoration: underline;
				}

				.end-review {
					position: absolute;
					z-index: 2;
					border: 1px solid red;
					color: red;
					border-radius: 0.25rem;
					transform: rotate(45deg);
					padding: 0.375rem 0.625rem;
					right: -1.25rem;
					top: 0.625rem;
					animation: endReview 1s;
					// border: 1px solid rgba(245, 108, 108, .7);
					// color: rgba(245, 108, 108, .8);
				}

				.end-review.not {
					border: 1px solid rgba(192, 192, 192, .7);
					color: silver;
				}

				.end-review.ing {
					border: 1px solid #67C23A;
					color: #67C23A;
				}

				.end-review.about {
					border: 1px solid #E6A23C;
					color: #E6A23C;
				}

				.time-group {
					padding: 1.25rem;

					.item {
						padding: 0 1rem;
						color: #999;

						.value {
							color: #666;
							padding-top: 0.25rem;
						}
					}
				}
			}
		}
	}

	.detail-tips {

		.title {
			text-align: center;
			font-size: 1rem;
		}

		.tips {
			text-align: center;
			font-size: 0.875rem;
			color: #999;
			margin-top: 1.25rem;
		}

		.dt-span {
			cursor: pointer;
			text-decoration: underline;
			color: #000;
			font-weight: bold;
		}

		.dt-span:hover {
			color: #4979ff;
		}

		::v-deep .el-dialog__footer {
			padding: 0;
		}
	}

	@keyframes endReview {
		from {
			transform: rotate(45deg) scale(3);
		}

		to {
			transform: rotate(45deg) scale(1);
		}
	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 923px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {}

	@media screen and (max-width: 922px) {
		.d-container {
			.content {
				.content-nav {
					.title {
						font-size: 1.125rem;
					}

					.right {
						.search {
							padding: 1.25rem 0 0;
							width: 100%;

							.el-input {
								width: auto;
								flex-grow: 1;

								::v-deep {
									.el-input {
										width: 100%;
									}
								}
							}
						}

						.sub-btn {
							padding: 1.25rem 0 0;
						}
					}
				}
			}
		}

		::v-deep {
			.el-dialog {
				width: 100% !important;
				margin-top: 40% !important;
				border-radius: 0 !important;
			}
		}
	}
</style>